import * as React from "react"

const Items = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="m8.3 2 5 .8.6 5L7.6 14 1.9 8.4l6.4-6.3ZM11 6.4A1 1 0 1 0 9.6 5 1 1 0 0 0 11 6.4Z" />
  </svg>
)

export default Items
